// extracted by mini-css-extract-plugin
export default {"cardsContainer":"YesOrNoPage_cardsContainer__FXIsM","moveUp":"YesOrNoPage_moveUp__KknY4"};